import { gql } from "apollo-boost";

export const INFER_RELATION = gql`
  query Query($texta: String!, $textb: String!, $numLabels: Int!) {
    relation(texta: $texta, textb: $textb, numLabels: $numLabels)
    similarity(texta: $texta, textb: $textb)
  }
`;
